"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capFirst = void 0;
const capFirst = (word) => {
    return word.replace(/\w/, (match) => match.toUpperCase()) || '';
};
exports.capFirst = capFirst;
